function Content({ sections }) {
  return (
    <div className="w-full  ">
      {sections.map((section) => (
        <div  key={section.id} className="">
          <h2 className="text-xl font-semibold text-primary ">
            {section.id}. {section.title}
          </h2>
          <div  className="text-blackText leading-relaxed">
            {Array.isArray(section.text) ? (
              section.text.map((line, index) => (
                <p key={index} className="mb-2">
                  {line}
                </p>
              ))
            ) : (
              <p>{section.text}</p>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}

export default Content; 